var _path, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEdgeAgent = function SvgEdgeAgent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.382 5.28c7.777 0 14.083 6.306 14.083 14.085 0 7.779-6.306 14.085-14.083 14.085C6.6 33.453.295 27.143.295 19.365.295 11.587 6.6 5.28 14.382 5.28Z",
    fill: "#E0F2FE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edge-agent_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.13 18.25h-.788a5 5 0 1 0-4.837 6.25h5.625a3.125 3.125 0 0 0 0-6.25Z",
    stroke: "#0086C9",
    strokeWidth: 1.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "edge-agent_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(6.88 12)",
    d: "M0 0h15v15H0z"
  })))));
};

export default SvgEdgeAgent;